import { ShippingPricesContainer } from '@/modules/ShippingPrices';

export const ShippingPrices = () => <ShippingPricesContainer />;

export default ShippingPrices;
